// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"201": "cca01960","51": "48b33566",}[chunkId] + ".chunk.js"
}